import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { Subject } from 'rxjs/Subject';
import { SocketFactory } from './socket-factory.service';
var DotcmsEventsService = (function () {
    function DotcmsEventsService(socketFactory, loggerService) {
        this.socketFactory = socketFactory;
        this.loggerService = loggerService;
        this.subjects = [];
    }
    /**
     * Close the socket
     */
    DotcmsEventsService.prototype.destroy = function () {
        this.socket.destroy();
        this.socketFactory.clean();
        this.socket = null;
    };
    /**
     * Start the socket
     */
    DotcmsEventsService.prototype.start = function () {
        var _this = this;
        this.loggerService.debug('start DotcmsEventsService');
        if (!this.socket) {
            this.socketFactory.createSocket().subscribe(function (socket) {
                _this.socket = socket;
                socket.message$().subscribe(function (data) {
                    if (!_this.subjects[data.event]) {
                        _this.subjects[data.event] = new Subject();
                    }
                    _this.subjects[data.event].next(data.payload);
                }, function (e) {
                    _this.loggerService.debug('Error in the System Events service: ' + e.message);
                }, function () {
                    _this.loggerService.debug('Completed');
                });
                _this.loggerService.debug('Connecting with socket');
                socket.start();
            });
        }
    };
    /**
     * This method will be called by clients that want to receive notifications
     * regarding incoming system events. The events they will receive will be
     * based on the type of event clients register for.
     *
     * @param clientEventType - The type of event clients will get. For example,
     *                          "notification" will allow a client to receive the
     *                          messages in the Notification section.
     * @returns {any} The system events that a client will receive.
     */
    DotcmsEventsService.prototype.subscribeTo = function (clientEventType) {
        if (!this.subjects[clientEventType]) {
            this.subjects[clientEventType] = new Subject();
        }
        return this.subjects[clientEventType].asObservable();
    };
    DotcmsEventsService.prototype.subscribeToEvents = function (clientEventTypes) {
        var _this = this;
        var subject = new Subject();
        clientEventTypes.forEach(function (eventType) {
            return _this.subscribeTo(eventType).subscribe(function (data) {
                return subject.next({
                    data: data,
                    eventType: eventType
                });
            });
        });
        return subject.asObservable();
    };
    return DotcmsEventsService;
}());
export { DotcmsEventsService };
DotcmsEventsService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DotcmsEventsService.ctorParameters = function () { return [
    { type: SocketFactory, },
    { type: LoggerService, },
]; };
//# sourceMappingURL=dotcms-events.service.js.map